
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { PlanningForm } from "@/components/PlanningForm";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [password, setPassword] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === "Pro Montages") {
      setIsAuthenticated(true);
    } else if (password === "fox") {
      navigate("/progress");
    } else if (password === "rice") {
      navigate("/progress2");
    } else if (password === "pollak") {
      navigate("/progress3");
    } else if (password === "carroll") {
      navigate("/progress4");
    } else {
      toast({
        title: "Incorrect Password",
        description: "Please try again with the correct password.",
        variant: "destructive",
      });
    }
  };

  if (isAuthenticated) {
    return (
      <div className="relative">
        <Button
          onClick={() => navigate("/")}
          variant="outline"
          className="absolute top-4 left-4"
        >
          Back to Home
        </Button>
        <PlanningForm />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <Button
          onClick={() => navigate("/")}
          variant="outline"
          className="mb-4"
        >
          Back to Home
        </Button>
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Enter Password
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-navy-500 focus:border-navy-500 focus:z-10 sm:text-sm"
            />
          </div>
          <div>
            <Button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-navy-600 hover:bg-navy-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy-500"
            >
              Log In
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
